import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http"
import { EnvironmentProviders, Injectable, Provider } from "@angular/core"
import { HeadersInterceptor } from "./lib/interceptors/headers.interceptor"
import { AuthInterceptor } from "./lib/interceptors/auth.interceptor"
import { errorInterceptor } from "./lib/interceptors/error.interceptor"
import { CORE_APP_CONFIG } from "./lib/utils/config.constants"
import { CoreConfig } from "./lib/interfaces/core-config"
import { ApiInterceptor } from "./lib/interceptors/api.interceptor"

@Injectable({ providedIn: 'root' })
export class CoreConfigService {
    constructor() {}
}

export const provideCore = (coreConfig: CoreConfig): Array<Provider | EnvironmentProviders> => {
    return [
        { provide: CORE_APP_CONFIG, useValue: coreConfig },
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
        provideHttpClient(
            withInterceptorsFromDi(), // fondamentale per fa funzionare questo: { provide: HTTP_INTERCEPTORS, useClass: xx, multi: true }
            withInterceptors([errorInterceptor]) // registra gli interceptor funzione (functional interceptor, non classi)
        ),
    ]
}